import Vue from 'vue';
import { Router, createRouter, createWebHistory} from 'vue-router'


const routes = [  
  {
    path: '/',
    name: 'Welcome to BPC One',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/about',
    name: 'About Us - BPC One',
    component: () => import('../views/About.vue')
  },
  {
    path: '/canvas',
    name: 'Canvas - BPC One',
     component: () => import('../views/Canvas.vue')
  },
  {
    path: '/contact',
    name: 'Connect with us - BPC One',
    component: () => import('../views/ContactView.vue')
  }
]



const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
        window.scrollTo(0,0);
      }
});

router.beforeEach((to, from, next) => {
  document.title = to.name ? String(to.name) : 'Welcome to BPC One'; 
  next();
});


export default router